
function experience_1() {
	return {
		date: "Sep 2021 - Dec 2023",
		title: "Voluunter - Study Club (PLUGIN)",
		sub: "Mentor - Web Development",
		description:
`Create and deliver material to 15 members, with 3 levels, namely Beginner, Intermediate and Advanced.\n The material presented includes HTML, CSS, JavaScript, Restfull API with Express JS, Front-End Web Development using React JS.`,
		keywords: [
			"The Benefits of Cloud Computing",
			"Tharindu",
			"Tharindu N",
			"Tharindu Nayanajith",
		],
		style: ``,
	};
}

function experience_2() {
	return {
		date: "Oct 2022 - Dec 2022",
		title: "Committee - Campust Events (INVOFEST)",
		sub: "IT Support",
		description:
			"Planned and organized technical requirements, including the Website as a platform for delivering event-related information.\n Responsibilities includedhandling technical issues that may arise during the event and findingquick and effectivesolutions.\n Successfully completed the development of the website using React JS within a timeframe of approximately 2 months.",
		style: ``,
	};
}

function experience_3() {
	return {
		date: "Aug 2023 - Jan 2024",
		title: "INTERNSHIP - PT. Sekawan Media",
		sub: "Front-End Developer",
		description:
			"Build and develop applications on client side websites and mobile apps. Responsible for handling technical problems that may arise during application development and finding solutions quickly and effectively.",
		style: ``,
	};
}

function experience_4() {
	return {
		date: "May 2024 - Oct 2024",
		title: "INTERNSHIP - Politeknik Harapan Bersama",
		sub:"Web Developer",
		description:
			" Build and develop applications on the client-side side of websites and mobile apps. Responsible for handling technical issues that may arise during application development and finding solutions quickly and effectively.",
		style: ``,
	};
}

const myArticles = [experience_1, experience_2, experience_3, experience_4];

export default myArticles;
